import { render, staticRenderFns } from "./AudanetTaskListSideMenu.vue?vue&type=template&id=d0b4aa28&scoped=true"
import script from "./AudanetTaskListSideMenu.vue?vue&type=script&lang=js"
export * from "./AudanetTaskListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./AudanetTaskListSideMenu.vue?vue&type=style&index=0&id=d0b4aa28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b4aa28",
  null
  
)

export default component.exports